import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import useCreateAttribute from "../../../hooks/variants/attributes/useCreateAttribute";

const CreateAttributeModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    attribute_name: "",
    unit: "",
  });

  const { handleSubmit } = useCreateAttribute({
    reset: () => {
      setFormData({ attribute_name: "", unit: "" });
      onClose();
    },
  });

  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleSaveAttribute = () => {
    if (!formData.attribute_name.trim()) {
      alert("Please fill in the attribute name");
      return;
    }
    handleSubmit(formData);
  };

  const handleCloseModal = () => {
    setFormData({ attribute_name: "", unit: "" });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
      <h1 className="text-xl font-semibold text-gray-600 px-4 py-3">
        Create Attribute
      </h1>
      <DialogContent className="">
        <div className="space-y-4">
          <TextField
            fullWidth
            label="Attribute Name"
            value={formData.attribute_name}
            onChange={handleInputChange("attribute_name")}
            variant="outlined"
            placeholder="Enter attribute name"
          />
          <TextField
            fullWidth
            label="Unit"
            value={formData.unit}
            onChange={handleInputChange("unit")}
            variant="outlined"
            placeholder="Enter unit"
          />
        </div>
      </DialogContent>
      <DialogActions className="p-4 gap-2">
        <Button onClick={handleCloseModal} variant="outlined" color="secondary">
          Back
        </Button>
        <Button
          onClick={handleSaveAttribute}
          variant="contained"
          color="primary"
        >
          Save Attribute
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAttributeModal;
